import { baseRequest } from '.'
import _get from 'lodash/get'
import _map from 'lodash/map'
import moment from 'moment-timezone'

export const getEventForms = async eventId => {
  try {
    const res = await baseRequest.get(`event/${eventId}/forms`)
    return _get(res, 'data.data')
  } catch (error) {
    console.error('Error fetching event forms:', error)
    throw error
  }
}

export const createEventForm = async (eventId, formData) => {
  const updatedCustomFieldsData = _map(formData.fields, field => {
    if (field.type !== 'select' && field.type !== 'radio' && field.type !== 'select_multi') {
      delete field.options
    }

    return field
  })

  try {
    const res = await baseRequest.post(`event/${eventId}/form`, {
      data: {
        attributes: {
          ...formData,
          startDate: moment(formData.startDate).isValid()
            ? moment(formData.startDate).format('YYYY-MM-DD HH:mm')
            : null,
          endDate: moment(formData.endDate).isValid()
            ? moment(formData.endDate).format('YYYY-MM-DD HH:mm')
            : null,
          fields: [
            {
              attributes: {
                fields: updatedCustomFieldsData,
                type: 'form',
              },
              type: 'custom_fields',
              relationships: [],
            },
          ],
        },
      },
    })
    return _get(res, 'data.data')
  } catch (error) {
    console.error('Error creating event form:', error)
    throw error
  }
}

export const getFormById = async (formId, eventId) => {
  try {
    const res = await baseRequest.get(`event/${eventId}/form/${formId}`)
    return _get(res, 'data.data')
  } catch (error) {
    console.error('Error fetching form:', error)
    throw error
  }
}

export const updateForm = async (formId, formData, eventId) => {
  const updatedCustomFieldsData = _map(formData.fields, field => {
    if (field.type !== 'select' && field.type !== 'radio' && field.type !== 'select_multi') {
      delete field.options
    }

    return field
  })
  try {
    const res = await baseRequest.put(`event/${eventId}/form/${formId}`, {
      data: {
        attributes: {
          ...formData,
          event_id: eventId,
          startDate: moment(formData.startDate).isValid()
            ? moment(formData.startDate).format('YYYY-MM-DD HH:mm')
            : null,
          endDate: moment(formData.endDate).isValid()
            ? moment(formData.endDate).format('YYYY-MM-DD HH:mm')
            : null,
          fields: [
            {
              attributes: {
                fields: updatedCustomFieldsData,
                type: 'form',
              },
              type: 'custom_fields',
              relationships: [],
            },
          ],
        },
      },
    })
    return _get(res, 'data.data')
  } catch (error) {
    console.error('Error updating form:', error)
    throw error
  }
}

export const deleteForm = async (formId, eventId) => {
  try {
    const res = await baseRequest.delete(`event/${eventId}/form/${formId}`)
    return _get(res, 'data.data')
  } catch (error) {
    console.error('Error deleting form:', error)
    throw error
  }
}

export const updateFormStatus = async (dataCaptureId, status, eventId, tags = []) => {
  try {
    const res = await baseRequest.put(`event/${eventId}/form/capture/${dataCaptureId}`, {
      data: {
        attributes: {
          status,
          tags,
        },
      },
    })
    return _get(res, 'data.data')
  } catch (error) {
    console.error('Error updating form status:', error)
    throw error
  }
}
